var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77778 1H2.11111C1.81643 1 1.53381 1.11706 1.32544 1.32544C1.11706 1.53381 1 1.81643 1 2.11111V3.77778M11 3.77778V2.11111C11 1.81643 10.8829 1.53381 10.6746 1.32544C10.4662 1.11706 10.1836 1 9.88889 1H8.22222M8.22222 11H9.88889C10.1836 11 10.4662 10.8829 10.6746 10.6746C10.8829 10.4662 11 10.1836 11 9.88889V8.22222M1 8.22222V9.88889C1 10.1836 1.11706 10.4662 1.32544 10.6746C1.53381 10.8829 1.81643 11 2.11111 11H3.77778",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.62c69776ba1166b316e004e628d82b7f.svg";
export { ForwardRef as ReactComponent };